import { AnnouncementStatus } from '@/app/enums/AnnouncementStatus';
import { type AnnouncementStatusOption } from '@/app/pages/notifications/announcements/core/_models';

export const MANAGED_ANNOUNCEMENTS_TABLE_KEY = 'announcement-managed-list';

export const ANNOUNCEMENT_STATUS_OPTIONS: AnnouncementStatusOption[] = [
  { value: AnnouncementStatus.DRAFT, label: 'Rascunho' },
  { value: AnnouncementStatus.PUBLISHED, label: 'Publicado' },
  { value: AnnouncementStatus.CLOSED, label: 'Encerrado' },
];
